"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge");
const Glossary = props => {
  const {
    contentFragments,
    topListFragment,
    topListStyles = {},
    contentStyles = {},
    linkStyles = {},
    customTheme = {}
  } = props;
  const theme = merge((0, _styles.useTheme)(), customTheme);
  const customTopListStyles = merge({
    marginBottom: "4rem"
  }, topListStyles);
  const customContentStyles = merge({
    "h2, h3": {
      fontFamily: theme.fontFamilies.default
    }
  }, contentStyles);
  const customLinkStyles = merge({
    cursor: "pointer",
    color: theme.palette.primary.main,
    fontFamily: theme.fontFamilies.semiBold,
    ":hover": {
      textDecoration: "underline"
    }
  }, linkStyles);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    role: "link",
    sx: {
      ...customTopListStyles,
      "a": {
        ...customLinkStyles
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: topListFragment
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "content-spacing"
  }, contentFragments.map(fragmentId => {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      key: fragmentId,
      id: `id_${fragmentId}`,
      sx: customContentStyles
    }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
      id: fragmentId
    }));
  })));
};

// Define propTypes;
Glossary.propTypes = {
  /* Array of fragment ids for content */
  contentFragments: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  /*  Content Styles (Default Value: {}) */
  contentStyles: _propTypes.default.object,
  /* Link styles (Default Value: {}) */
  linkStyles: _propTypes.default.object,
  /* TopList fragment id */
  topListFragment: _propTypes.default.string.isRequired,
  /*  TopList fragment styles (Default Value: {}) */
  topListStyles: _propTypes.default.object
};

// Export component as default;
var _default = exports.default = Glossary;